<template>
  <div class="body">
    <div class="user_body">
      <div class="line2"></div>
      <div class="content">
        <el-input placeholder="请输入内容" clearable v-model="keyword" @keyup.enter.native="handleSearch" class="input_wiht">
          <i slot="suffix" style="cursor: pointer;" class="el-input__icon el-icon-search" @click="handleSearch"></i>
        </el-input>
        <div class="nav_list">
          <div class="nav_item_out" v-for="(item, index) in navList" :key="index" @click="goNav(index)">
            <span :class="currentIndex == index ? 'color_orage' : 'color_dark_green'">{{ item }}</span>
            <div :class="currentIndex == index ? 'line' : 'line_white'"></div>
          </div>
        </div>
        <div class="result">找到{{ total }}个结果</div>

        <div class="result_list" v-if="currentIndex == 0">
          <div class="result_item" v-for="(item, index) in twoLevelCate" :key="index">
            <img src="@/assets/user_icon1.png" class="res_left">
            <div class="res_right">
              <span class="res_title">{{ item.title }}</span>
              <span class="res_content">{{ item.sdesc }}</span>
              <div>
                <span class="res_btns" @click="toSubCate(item.id, 'buy')">选购 ></span>
                <span class="res_btns" @click="toSubCate(item.id)">探索了解 ></span>
              </div>
            </div>
          </div>
        </div>


        <div class="result_list" v-if="currentIndex == 1">
          <div class="result_item" v-for="(item, index) in dowloadList" :key="index">
            <div class="res_right">
              <span class="res_title">{{ item.title }}</span>
              <span class="res_content">{{ item.sdesc }}</span>
              <div>
                <span class="res_btns" @click="goDownload(item.url)">{{ item.url }}</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- <div class="footer" v-if="currentIndex == 0">
      <el-pagination @current-change="pageChange" :current-page.sync="currentPage1" :page-size="10"
        layout="prev, pager, next" :total="total" small></el-pagination>
    </div> -->
  </div>
</template>

<script>
import bus from "@/components/eventBus.js";
export default {
  name: "SuggestionsView",
  data() {
    return {
      currentIndex: 0,
      navList: ["意向采购", "资料下载", "技术咨询"],
      currentPage1: 1,
      total: 10,
      dowloadList: [],
      twoLevelCate: [],
      keyword: ''
    };
  },
  watch: {
    '$route.query.tab': {
      handler(newVal) {
        if (newVal == 2) {
          this.currentIndex = 1;
          this.getDownloadList();
        } else if (newVal == 1) {
          this.currentIndex = 0;
          this.currentPage1 = 1;
          this.getTwoLevelCate();
        }
      },
      immediate: true
    },
    '$route.query.keyword':{
      handler(newVal){
        this.keyword = newVal
        this.handleSearch()
      },
      immediate:true
    }
  },
  created() {
    if (this.$route.query.tab) {
      return
    }
  },
  mounted() { },
  methods: {
    goNav(index) {
      this.keyword = '';
      switch (index) {
        case 0:
          this.currentIndex = index;
          this.getTwoLevelCate();
          break;
        case 1:
          this.currentIndex = index;
          this.getDownloadList();
          break;
        case 2:
          this.$router.push('/consultationview');
          break;
      }

    },
    getTwoLevelCate() {
      this.$api.searchGoods({
        page: this.currentPage1,
        keyword: this.keyword,
        limit: 10
      }).then(res => {
        if (res.code == 1) {
          this.twoLevelCate = res.data;
          this.total = res.data.length;
        }
      }).catch(err => {
        console.log(err);
      });
    },
    getDownloadList() {
      this.$api.getDownloadList({
        keyword: this.keyword
      }).then(res => {
        if (res.code == 1) {
          this.dowloadList = [...res.data.list];
          this.total = res.data.list.length;
        }
      }).catch(err => {
        console.log(err);
      });
    },
    handleSearch() {

      if (this.currentIndex == 0) {
        this.currentPage1 = 1;
        this.getTwoLevelCate();
      } else {
        this.getDownloadList();
      }
    },
    pageChange(page) {
      this.currentPage1 = page;
      // this.getDownloadList();
    },
    goDownload(url) {
      window.open(url, '_blank');
    },
    toSubCate(id, type) {
      // this.$router.push({
      //   path: '/cellslineinfo/' + id,
      //   query: { to: type }
      // })
      this.$router.push({ path: "/buyproduct/"+id});
    }
  }
};
</script>

<style lang="less" scoped>
.body {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  background: #ffffff;
}

.user_body {
  background: #ffffff;
  box-sizing: border-box;
  padding-top: 90px;
}

.content {
  margin-top: 20px;
}

.line2 {
  width: 100%;
  height: 1px;
  background: #ebebeb;
}

.input_wiht {
  width: 40%;
  background: #ffffff;
  margin-left: 20%;
  margin-right: 20%;
  height: 40px !important;
  line-height: 40px;
}

.nav_list {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #ebebeb;
  padding-left: 20%;
  padding-right: 20%;
  box-sizing: border-box;
  margin-top: 30px;
}

.nav_item {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 88px;
  font-size: 20px;
  font-weight: 500;
}

.nav_item img {
  width: 14px;
  height: 14px;
  margin-left: 5px;
}

.nav_item_out {
  cursor: pointer;
  margin-left: 10px;
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}

.line {
  width: 60px;
  height: 2px;
  background: #3c9c8f;
  border-radius: 10px;
  margin-top: 10px;
}

.line_white {
  width: 60px;
  height: 2px;
  background: #ffffff;
  border-radius: 10px;
  margin-top: 10px;
}

.color_orage {
  color: #3c9c8f;
}

.color_dark_green {
  color: #666666;
}

.result {
  color: #999999;
  font-size: 12px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-left: 20%;
  padding-right: 20%;
}

.result_list {
  margin-left: 20%;
  margin-right: 20%;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.result_item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;
}

.res_left {
  width: 144px;
  height: 144px;
  margin-right: 15px;
}

.res_right {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.res_title {
  color: #000000;
  font-size: 24px;
  font-weight: 500;
  line-height: 35px;
}

.res_content {
  color: #333333;
  font-size: 18px;
  font-weight: 500;
  line-height: 32.4px;
  margin-top: 10px;
}

.res_btns {
  cursor: pointer;
  color: #3c9c8f;
  font-size: 16px;
  line-height: 26px;
  margin-right: 40px;
  margin-top: 10px;
}

.footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.el-input {
  position: relative;
  font-size: 16px;
  font-weight: 400;
  background: #ffffff !important;
}
</style>
